import spinner from '../utils/rbata.spinner';
import urlService from '../services/rbata.urlService';
import logger from '../utils/rbata.logger';
import miniCart from './rbata.miniCart';

const voucherHandling = {
    $body:                  undefined,
    $voucherErrorContainer: undefined,
    $voucherFormGroup:      undefined,
    cacheSelectors() {
        this.$body                  = $('body');
        this.$voucherErrorContainer = $('.js-voucher-error-container');
        this.$voucherFormGroup      = $('.js-voucher-form-group');
    },
    handleVoucherAdd(voucherValue, $currentTarget, reload = true) {
        let request = $.ajax({
            url:         `${urlService.getBaseUrl()}cart/addvoucher`,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                id: voucherValue,
            })
        });

        spinner.visibility(true);
        this.clearErrorMessage();
        request.done((response) => {
            if (response.success === true) {
                if (reload) {
                    window.location.reload();
                } else {
                    miniCart.load(true);
                }
            } else {
                this.renderErrorMessage(response.message);
            }
            $currentTarget.find('input').val('');
            spinner.visibility(false);
        });
        request.fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in voucherHandling.handleVoucherAdd`);
            window.location.reload();
        });
    },
    renderErrorMessage(message) {
        this.$voucherErrorContainer.html(message);
        this.$voucherFormGroup.addClass('is-invalid');
    },
    clearErrorMessage() {
        this.$voucherErrorContainer.empty();
        this.$voucherFormGroup.removeClass('is-invalid');
    },
    handleVoucherDeletion(voucherValue, urlFragement, reload = true) {
        let request = $.ajax({
            url:         `${urlService.getBaseUrl()}cart/` + urlFragement,
            method:      'POST',
            dataType:    'json',
            contentType: 'application/json',
            data:        JSON.stringify({
                id: voucherValue,
            })
        });

        spinner.visibility(true);
        request.done((response) => {
            if (response.success === true) {
                if (reload) {
                    window.location.reload();
                } else {
                    miniCart.load(true);
                }
            } else {
                this.renderErrorMessage(response.message);
                spinner.visibility(false);
                if (response.outOfStockEntries.length) {
                    // if there are outOfStockEntries in the response, success is false but product amount is changed
                    if (reload) {
                        window.location.reload();
                    } else {
                        miniCart.load(true);
                    }
                }
            }
            spinner.visibility(false);
        });
        request.fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in voucherHandling.handleVoucherDeletion`);
            window.location.reload();
        });
    },
    bindEvents() {
        this.$body.on('submit', '.js-add-voucher', (evt) => {
            evt.preventDefault();
            const $currentTarget = $(evt.currentTarget);
            const voucherValue   = $currentTarget.find('input').val();
            const pageReload     = !$currentTarget.closest('.js-miniCart__voucher').length;

            if (voucherValue === '') {
                return;
            }
            this.handleVoucherAdd(voucherValue, $currentTarget, pageReload);
        });
        this.$body.on('click', '.js-remove-voucher', (evt) => {
            evt.preventDefault();
            const voucherCode    = evt.currentTarget.dataset.code;
            const $currentTarget = $(evt.currentTarget);
            const pageReload     = !$currentTarget.closest('.js-miniCart__voucher').length;

            this.handleVoucherDeletion(voucherCode, 'removevoucher', pageReload);
        });
        this.$body.on('click', '.js-remove-giftcard', (evt) => {
            evt.preventDefault();
            const giftCardCode   = evt.currentTarget.dataset.code;
            const $currentTarget = $(evt.currentTarget);
            const pageReload     = !$currentTarget.closest('.js-miniCart__voucher').length;

            this.handleVoucherDeletion(giftCardCode, 'removegiftcard', pageReload);
        });
        this.$body.on('change keyup', '.js-voucher-form-control', (evt) => {
            evt.preventDefault();

            $(evt.currentTarget).next('.btn').prop('disabled', false);
        });
        this.$body.on('focusin', '.js-voucher-form-control', (evt) => {
            // bypass bootstrap modals guard against infinite focus loop
            evt.stopImmediatePropagation();
        });
    }
};

$(() => {
    if ($('.js-add-voucher').length || $('.js-cart-tooltip').length) {
        voucherHandling.cacheSelectors();
        voucherHandling.bindEvents();
    }
});

export default voucherHandling;
